module.exports = __webpack_public_path__ + "static/media/deal-1.f59d5e37.png";